import { fetchPreloadData } from '../api/preload';
import { SET_GLOBAL_LOADING } from './app-ui';
import { getTokenData, isTokenValid } from '../utils/token';
import { getProfile } from '../actions/auth';
import { getQuestionnairesResults } from './questionnaires';

export const GET_PRELOAD_DATA_FETCH = 'GET_PRELOAD_DATA_FETCH';
export const GET_PRELOAD_DATA_SUCCESS = 'GET_PRELOAD_DATA_SUCCESS';
export const GET_PRELOAD_DATA_FAIL = 'GET_PRELOAD_DATA_FAIL';

export const getPreloadData = () => async dispatch => {
  dispatch({ type: GET_PRELOAD_DATA_FETCH });
  dispatch({ type: SET_GLOBAL_LOADING, globalLoading: true });
  try {
    const response = await fetchPreloadData();
    const { voting, info, school, voteDate } = response.data;
    dispatch({
      type: GET_PRELOAD_DATA_SUCCESS,
      voteDate,
      voting,
      info,
      school
    });
    dispatch({ type: SET_GLOBAL_LOADING, globalLoading: false });
  } catch (e) {
    dispatch({
      type: GET_PRELOAD_DATA_FAIL,
      message: e
    });
    dispatch({ type: SET_GLOBAL_LOADING, globalLoading: false });
  }

  const tokenData = getTokenData();
  if (isTokenValid(tokenData)) {
    dispatch(getProfile());
    dispatch(getQuestionnairesResults());
  }
};
